module.exports = __webpack_public_path__ + "media/slider/Banner-9-India-17d04109.jpg";